import { useTranslation } from 'react-i18next';

import { ImageTile } from './ImagePreview';
import type { SentImage } from './file-meta';

const MAX_GRID_TILES = 4;

interface ImageGridProps {
  images: SentImage[];
  onOpen: (index: number, opener: HTMLButtonElement) => void;
}

export function ImageGrid({ images, onOpen }: ImageGridProps) {
  const { t } = useTranslation('ai-cio');
  const tiles = images.slice(0, MAX_GRID_TILES);
  const hiddenCount = images.length - tiles.length;

  return (
    <div className="grid w-[280px] max-w-full grid-cols-2 gap-2">
      {tiles.map((image, index) => (
        <ImageTile
          key={image.id}
          image={image}
          label={t('sentFiles.openImageNamed', 'Open {{name}}', { name: image.name })}
          moreCount={index === tiles.length - 1 ? hiddenCount : 0}
          onOpen={(opener) => {
            onOpen(index, opener);
          }}
          className="h-[100px]"
        />
      ))}
    </div>
  );
}
